import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './DicasSaude.css';

const dicas = [
    {
        icon: 'tint',
        title: 'Beba Água',
        text: 'Manter-se hidratado é fundamental para o bom funcionamento do corpo. Tente beber pelo menos 2 litros de água por dia.'
    },
    {
        icon: 'walking',
        title: 'Movimente-se',
        text: 'A prática regular de atividades físicas fortalece o coração, melhora a circulação e ajuda a controlar o peso.'
    },
    {
        icon: 'apple-alt',
        title: 'Alimentação Saudável',
        text: 'Uma dieta rica em frutas, verduras e legumes fornece os nutrientes essenciais para sua saúde e bem-estar.'
    },
    {
        icon: 'bed',
        title: 'Durma Bem',
        text: 'Uma boa noite de sono é crucial para a recuperação do corpo e da mente. Tente dormir de 7 a 8 horas por noite.'
    },
];

const DicasSaude = () => {
    const [indiceDica, setIndiceDica] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setIndiceDica(prevIndice => (prevIndice + 1) % dicas.length);
        }, 10000); // Muda a dica a cada 10 segundos

        return () => clearInterval(intervalId);
    }, []);

    const dicaAtual = dicas[indiceDica];

    return (
        <div key={indiceDica} className="dica-saude-container">
            <FontAwesomeIcon icon={['fas', dicaAtual.icon]} size="4x" className="dica-saude-icon" />
            <h3 className="dica-saude-title mt-4">{dicaAtual.title}</h3>
            <p className="dica-saude-text lead">{dicaAtual.text}</p>
        </div>
    );
};

export default DicasSaude;
